<template>
  <div class="AuthErrorPageView">
    <Error406 />
  </div>
</template>

<script>
import store from '@/store';
import { mapGetters } from 'vuex';
import Error406 from '@/components/Common/Error406';

export default {
  name: 'AuthErrorPage',
  store,
  components: { Error406 },
  computed: {
    ...mapGetters([]),
  },
};
</script>



// WEBPACK FOOTER //
// src/views/AuthErrorPage.vue